import SEO from "@/components/SEO";
import ChatbotPricing from "./ChatbotPricing";
import { seoConfig } from "@/config/seo.config";

export default function Pricing() {
  
  return (
    <>
    <SEO {...seoConfig.pricing} />
      <ChatbotPricing />
    </>
  );

}
